import { Group } from '@mantine/core';
import type { ScanTagProps } from './ScanTag';
import { ScanTag } from './ScanTag';

export const TagsTooltip = (props: { tags: ScanTagProps[] }) => {
  return (
    <Group gap={4} display="inline-flex" wrap="nowrap">
      {props.tags.map((i, idx) => (
        <ScanTag key={idx} {...i} />
      ))}
    </Group>
  );
};
